/**
 * Resolve public class cover image URLs for <img src>.
 *
 * The public API returns either an absolute URL (Unsplash/CDN) or a relative
 * API path (`/public/classes/:id/cover-image`) for uploaded covers. Relative
 * paths must be resolved against the API base URL (like profile images).
 */

import { apiFetchUrl } from '@constants/apiConfig';

/**
 * Unsplash credit belongs to the external photo only.
 * An uploaded cover has no imageUrl, so it must not keep the previous credit.
 */
export function unsplashCreditForCover(
  imageUrl?: string | null,
  attribution?: string | null
): string | null {
  const url = imageUrl?.trim() ?? '';
  const credit = attribution?.trim() ?? '';
  if (!url.startsWith('http') || !credit) return null;
  return credit;
}

export function resolvePublicClassImageSrc(imageUrl?: string | null): string | undefined {
  if (!imageUrl) {
    return undefined;
  }
  const trimmed = imageUrl.trim();
  if (!trimmed) {
    return undefined;
  }
  if (trimmed.startsWith('/')) {
    return apiFetchUrl(trimmed);
  }
  return trimmed;
}
